import React from 'react';

function TextNode(props) {
  const {
    className,
    as = 'div',
    style,
    children
  } = props;
  const Element = as;
  return /*#__PURE__*/React.createElement(Element, {
    className: className,
    style: style
  }, children);
}

export { TextNode as default };
//# sourceMappingURL=index.js.map
